import React from 'react';
import Barcode from 'react-barcode';

/**
 * Barcode Display Component
 * Renders a scannable barcode for products
 * Used in shelf mode for staff to scan products for ordering
 * Supports EAN-13, EAN-8, and CODE128 (for any length)
 */
export default function BarcodeDisplay({ barcode, width = 1.5, height = 20, fontSize = 9 }) {
  // Validate barcode exists
  if (!barcode || typeof barcode !== 'string') {
    return null;
  }

  // Clean the barcode (remove spaces, dashes, etc.)
  const cleanBarcode = barcode.replace(/[^0-9]/g, '');
  
  // If no digits at all, don't show anything
  if (cleanBarcode.length === 0) {
    return (
      <div
        style={{
          fontSize: fontSize,
          fontWeight: 400,
          color: 'var(--color-text-secondary)',
          textAlign: 'center',
          fontFamily: 'monospace',
          marginTop: '4px',
        }}
      >
        {barcode}
      </div>
    );
  }
  
  // Determine format based on length
  let format = 'CODE128'; // Default - works with any length
  if (cleanBarcode.length === 8) {
    format = 'EAN8';
  } else if (cleanBarcode.length === 13) {
    format = 'EAN13';
  }
  // For any other length, CODE128 will handle it

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '0px',
        background: 'white',
        padding: '2px',
        borderRadius: '2px',
      }}
    >
      <Barcode
        value={cleanBarcode}
        format={format}
        width={width}
        height={height}
        fontSize={fontSize}
        margin={0}
        displayValue={true}
        background="white"
        lineColor="black"
      />
    </div>
  );
}
